import { readRecentViews, registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

/**
 * 1. TODO: Make this line conditional based on recent view type.
 *    We're only using `product` type currently, so punting on figuring out the best solution for that.
 */

registerComponent(
  "recent-views",
  class RecentViews extends WYATTElement {
    static observedAttributes = ["has-views"];

    constructor() {
      super();

      this.section = this.closest(".shopify-section");

      this.allViews = readRecentViews();
      this.views = this.allViews[this.config.type];

      if (this.views?.length) {
        this.views.slice(0, this.config.max).forEach(this.getView.bind(this));
      }
    }

    attributeChangedCallback(attribute, oldValue, newValue) {
      if (attribute === "has-views") {
        const addOrRemove = newValue === "true" ? "remove" : "add";

        this.section.classList[addOrRemove]("hidden");
      }
    }

    async getView(view) {
      const url = `${WYATT.routes.root}products/${view.handle}?view=recent-view`; /* [1] */

      const response = await fetch(url);

      if (response.ok) {
        const html = await response.text();
        this.renderView(html);
        this.setAttribute("has-views", true);
      }
    }

    renderView(html) {
      const gridCell = document.createElement("div");

      gridCell.classList.add("recent-views__item");
      gridCell.innerHTML = html;

      this.updateSizes(gridCell); /* [1] */

      this.appendChild(gridCell);
    }

    updateSizes(gridCell) {
      const images = gridCell.querySelectorAll("[sizes]");
      let sizes = "";

      if (this.config.fullWidth) {
        sizes = `(min-width: ${WYATT.config.breakPoints.wide}px) calc(100vw / ${this.config.columns}), (min-width: ${WYATT.config.breakPoints.medium}px) 25vw, 50vw`;
      } else {
        sizes = `(min-width: ${WYATT.config.breakPoints.wide}px) calc(90vw / ${this.config.columns}), (min-width: ${WYATT.config.breakPoints.medium}px) calc(90vw / 4), calc(90vw / 2)`;
      }

      images.forEach((image) => image.setAttribute("sizes", sizes));
    }
  },
);
